import { Consts } from "../pages/consts";
import drugGreen from "../../resources/img/drug_green.png";
import drugRed from "../../resources/img/drug_red.png";
import drugYellow from "../../resources/img/drug_yellow.png";
import drugOrange from "../../resources/img/drug_orange.png";
import drugGrey from "../../resources/img/drug_grey.png";
import i18n from "i18next";
import { buildInteractionParam } from "../pages/utils";

export const calculateDdiColor = (ddis, role) => {
  if (ddis?.length > 0 && ddis[0].relevance) {
    let maxRelevance = Math.max(...ddis?.map(ddi => ddi?.relevance?.abdataCode || 0));

    /*return role === Consts.PATIENT
      ? maxRelevance > 20 && maxRelevance <= 60
        ? "#1565a0"
        : Consts.GREY
      : calculateDdiColorByRelevance(maxRelevance);*/
    return calculateDdiColorByRelevance(maxRelevance);
  }

  return Consts.GREY;
};

export const calculateDdiColorByRelevance = (relevanceCode) => {
  switch (relevanceCode) {
    case 30:
      return "#FFFFE0";
    case 40:
      return "#FFA500";
    case 50:
    case 60:
      return "#f10909";
    default: // incl. 0, 80 and 90
      return "#627079";
  }
};

const calculateDrug = (code) => {
  switch (code) {
    case 0:
    case 80:
    case 90:
      return drugGrey;
    case 10:
    case 20:
      return drugGreen;
    case 30:
      return drugYellow;
    case 40:
      return drugOrange;
    case 50:
    case 60:
      return drugRed;
    default:
      return drugGrey;
  }
};

export const buildIntakeParams = (drug) => {
  if (drug?.timingType === Consts.DAY_TIMES) {
    const times = ["", "", "", ""];
    const dosages = [0, 0, 0, 0];
    const defaultTimes = ["8:00", "13:00", "18:00", "23:00"];
    let unit;

    drug?.intakes?.forEach((intake) => {
      if (intake?.intakeTime?.includes(":")) {
        const hour = +intake?.intakeTime?.split(":")[0];
        unit = intake?.dosageUnit;
        const index = calculateDayTimeIndex(hour);

        if (index !== undefined) {
          dosages[index] = intake?.dosage?.toString();
          times[index] = intake?.intakeTime;
        }
      }
    });

    times?.forEach((time, i) => {
      if (time === "") {
        times[i] = defaultTimes[i];
      }
    });

    return { times, dosages, unit };
  }

  return null;
};

export const calculateDayTimeIndex = (hour) => {
  if (hour >= 5 && hour < 12) {
    return 0; // Morning
  } else if (hour >= 12 && hour < 17) {
    return 1; // Noon
  } else if (hour >= 18 && hour < 22) {
    return 2; // Evening
  } else if (hour >= 23 || hour < 5) {
    return 3; // Night
  }
};

export const buildNodes = (drugs, notSpecifiedText) => {
  let abs = [-200, 200, 200, -200, 0, 0, -100, 100, -100, 100, -250, 250];
  let ord = [-150, -150, 50, 50, -250, 150, -225, -225, 125, -225, -50, -50];

  if (drugs) {
    return drugs?.map((drug, i) => {
      const hasDgi = drug?.dgis?.length > 0;
      const drugImg = calculateDrug(drug?.maxDdi);

      const product = drug?.productName === Consts.NOT_SPECIFIED || drug?.productName === Consts.ANY
        ? `(${notSpecifiedText.toLowerCase()})`
        : drug?.productName;

      return {
        id: drug?.id,
        name: drug?.productName,
        label: drug?.activeSubstance?.replaceAll("&&&", ", "),// ToDo replace &&& with ; if needed
        font: {
          color: hasDgi ? Consts.WHITE : "#1565a0",
          background: hasDgi ? "#1565a0" : Consts.NONE,
          size: 16,
          padding: 5
        },
        labelHighlightBold: true,
        title: "ATC code: " + drug?.atc + ", " + product,
        shape: "image",
        image: drugImg,
        size: 10,
        x: abs[i],
        y: ord[i],
      };
    });
  }

  return null;
};

const getDrugIdBySubstance = (drugs, substance) => {
  const drug = drugs?.find(drug => drug?.activeSubstance?.toLowerCase() === substance?.toLowerCase());
  return drug ? drug?.id : undefined;
};

export const buildEdges = (drugs, role) => {
  const myEdges = [];

  if (drugs) {
    drugs?.forEach((drug) => {
      drug?.ddis?.forEach((ddi) => {
        /*const color =
          role === Consts.PATIENT
            ? "#1565a0"
            : calculateDdiColorByRelevance(ddi?.relevance?.abdataCode);*/

        const color = calculateDdiColorByRelevance(ddi?.relevance?.abdataCode);

        myEdges?.push({
          from: drug?.id,
          title: buildInteractionParam(ddi?.relevance?.description, false),
          to: getDrugIdBySubstance(drugs, ddi?.ddiDrug?.activeSubstance),
          arrows: {
            from: { enabled: false, type: "vee" },
            to: { enabled: false, type: "vee" },
          },
          color: {
            color: color,
            highlight: color,
            opacity: 0.2,
          },
        });
      });
    });
  }

  return myEdges;
};

export const findProductName = (drugs, substance, notSpecifiedText) => {// TODO check the drugs and substance parameter where this function is called
  const drug = drugs?.find(drug => drug?.activeSubstance?.toLowerCase() === substance?.toLowerCase());

  return drug ? drug?.productName && drug?.productName === Consts.ANY
    ? `(${notSpecifiedText.toLowerCase()})`
    : drug?.productName : "";
};

export const buildIntakesArray = (size, time, dosage, dosageUnit) => {
  return Array.from({ length: size }, () => ({ intakeTime: time, dosage, dosageUnit }));
};

export const getDiseaseName = (disease) => {
  return disease?.icd10Name[i18n.language?.toUpperCase()] ||
    disease?.icd10Name["EN"] ||
    disease?.icd10Name["DE"] || "";
};

export const buildDdiProduct = (ddiDrug, notSpecifiedText) => {
  return ddiDrug
    ? ddiDrug?.productName && ddiDrug?.productName === Consts.ANY
      ? notSpecifiedText.toLowerCase()
      : ddiDrug?.productName
    : "";
}
